import { useEffect, useState } from 'react'

function useSessionStorageState<T>(key: string, defaultValue: T): [T, React.Dispatch<React.SetStateAction<T>>] {
    const [state, setState] = useState<T>(() => {
        try {
            const stored = sessionStorage.getItem(key);
            return stored !== null ? JSON.parse(stored) as T : defaultValue;
        } catch (error) {
            console.warn(`Error parsing sessionStorage value for key "${key}":`, error);
            return defaultValue;
        }
    });

    useEffect(() => {
        try {
            sessionStorage.setItem(key, JSON.stringify(state));
        } catch (error) {
            console.error(`Error saving to sessionStorage for key "${key}":`, error);
        }
    }, [key, state]);

    return [state, setState];
}

export default useSessionStorageState